module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.maskshow) ? _c('div', {
    staticClass: "mask1"
  }) : _vm._e(), _vm._v(" "), (_vm.maskshow1) ? _c('div', {
    staticClass: "mask2"
  }) : _vm._e(), _vm._v(" "), (_vm.maskshow2) ? _c('div', {
    staticClass: "mask3"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showTips),
      expression: "!showTips"
    }]
  }, [_c('div', {
    staticClass: "cover"
  }, [_c('van-swipe', {
    staticClass: "my-swipe",
    attrs: {
      "autoplay": 3000,
      "indicator-color": "white"
    }
  }, _vm._l((_vm.goodsInfo.img_list), function(item, index) {
    return _c('van-swipe-item', {
      key: index
    }, [_c('img', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "src": item
      }
    })])
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "price"
  }, [_c('span', {
    staticClass: "symbol"
  }, [_vm._v("￥")]), _vm._v(" "), _c('span', {
    staticClass: "num"
  }, [_vm._v(_vm._s(_vm.goodsInfo.price))])]), _vm._v(" "), (_vm.goodsInfo.infinite !== 1) ? _c('div', {
    staticClass: "inventory-num"
  }, [_vm._v("库存: " + _vm._s(_vm.goodsInfo.count))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "goods-title"
  }, [_vm._v(_vm._s(_vm.goodsInfo.name))]), _vm._v(" "), _c('div', {
    staticClass: "goods-detail"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("详情")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "dompurify-html",
      rawName: "v-dompurify-html",
      value: (_vm.goodsInfo.desc),
      expression: "goodsInfo.desc"
    }],
    staticClass: "text-desc"
  })]), _vm._v(" "), _c('div', {
    staticClass: "buy-btn"
  }, [_c('van-button', {
    class: {
      'disabled': _vm.goodsInfo.infinite == 0 && _vm.goodsInfo.count == 0
    },
    attrs: {
      "type": "primary",
      "round": "",
      "size": "large"
    },
    on: {
      "click": _vm.toConfirm
    }
  }, [_vm._v("立即购买")])], 1), _vm._v(" "), (_vm.confirm) ? _c('div', {
    staticClass: "consultTeacher"
  }, [_c('div', {
    staticClass: "consultTeacherMain"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "TeacherList"
  }, [_c('div', {
    staticClass: "teacherCell order"
  }, [_c('img', {
    staticClass: "cover",
    attrs: {
      "src": _vm.goodsInfo.cover
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "goods-content"
  }, [_c('div', {
    staticClass: "goods-title"
  }, [_vm._v(_vm._s(_vm.goodsInfo.name))]), _vm._v(" "), _c('div', {
    staticClass: "goods-price"
  }, [_c('span', {
    staticClass: "money-symbol"
  }, [_vm._v("￥")]), _vm._v(" "), _c('span', {
    staticClass: "money-num"
  }, [_vm._v(_vm._s(_vm.goodsInfo.price))]), _vm._v(" "), _c('div', {
    staticClass: "stepper"
  }, [_c('van-stepper', {
    attrs: {
      "theme": "round",
      "integer": ""
    },
    model: {
      value: (_vm.goodsNum),
      callback: function($$v) {
        _vm.goodsNum = $$v
      },
      expression: "goodsNum"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "form-wrap"
  }, [_c('van-cell-group', _vm._l((_vm.formList), function(item, index) {
    return _c('van-field', {
      key: index,
      attrs: {
        "label": item.name,
        "placeholder": ("请输入" + (item.name)),
        "required": (item.required == 1)
      },
      model: {
        value: (_vm.form[("custom" + (item.id))]['value']),
        callback: function($$v) {
          _vm.$set(_vm.form[("custom" + (item.id))], 'value', $$v)
        },
        expression: "form[`custom${item.id}`]['value']"
      }
    })
  }), 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('span', {
    staticClass: "sum-text"
  }, [_vm._v("合计：")]), _vm._v(" "), _c('div', {
    staticClass: "sum-money"
  }, [_c('span', [_vm._v("￥")]), _vm._v(" "), _c('span', [_vm._v(_vm._s((_vm.goodsInfo.price * _vm.goodsNum).toFixed(2)))])]), _vm._v(" "), _c('div', {
    staticClass: "comfirm-btn"
  }, [_c('button', {
    on: {
      "click": _vm.submitOrdert
    }
  }, [_vm._v("提交订单")])])]), _vm._v(" "), _c('img', {
    staticClass: "closeBtn",
    attrs: {
      "src": "https://tengfaceliveuser.tengface.net/web/wx-user/img/yuan_close.png"
    },
    on: {
      "click": _vm.closeBtnClicked
    }
  })])]) : _vm._e(), _vm._v(" "), _c('van-popup', {
    staticClass: "qqLogin",
    style: ({
      width: '70%'
    }),
    attrs: {
      "close-on-click-overlay": false,
      "overlay-style": {
        zIndex: '2001'
      }
    },
    model: {
      value: (_vm.showWxPopUp),
      callback: function($$v) {
        _vm.showWxPopUp = $$v
      },
      expression: "showWxPopUp"
    }
  }, [_c('div', {
    staticClass: "loginWay"
  }, [_c('div', {
    staticClass: "qqtitle"
  }, [_vm._v("微信授权登录即可查看详情")]), _vm._v(" "), _c('div', {
    staticClass: "qqBox"
  }, [_c('van-button', {
    staticStyle: {
      "padding": "0px 45px"
    },
    attrs: {
      "round": "",
      "type": "primary"
    },
    on: {
      "click": _vm.wxloginTap
    }
  }, [_vm._v("确认登录")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-top": "30px",
      "color": "#c9c9c9"
    },
    on: {
      "click": _vm.closeWindow
    }
  }, [_vm._v("取消")])], 1)])]), _vm._v(" "), _c('van-popup', {
    staticClass: "qqLogin",
    style: ({
      width: '70%'
    }),
    attrs: {
      "close-on-click-overlay": false,
      "overlay-style": {
        zIndex: '2001'
      }
    },
    model: {
      value: (_vm.showAliPopUp),
      callback: function($$v) {
        _vm.showAliPopUp = $$v
      },
      expression: "showAliPopUp"
    }
  }, [_c('div', {
    staticClass: "loginWay"
  }, [_c('div', {
    staticClass: "qqtitle"
  }, [_vm._v("支付宝授权登录即可查看详情")]), _vm._v(" "), _c('div', {
    staticClass: "qqBox"
  }, [_c('van-button', {
    staticStyle: {
      "padding": "0px 45px"
    },
    attrs: {
      "round": "",
      "type": "primary"
    },
    on: {
      "click": _vm.aliLoginTap
    }
  }, [_vm._v("确认登录")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-top": "30px",
      "color": "#c9c9c9"
    },
    on: {
      "click": _vm.closeAliWindow
    }
  }, [_vm._v("取消")])], 1)])])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showTips),
      expression: "showTips"
    }],
    staticClass: "tips"
  }, [_c('img', {
    attrs: {
      "src": require("../../../statics/imgs/no.png")
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.tipsText))])]), _vm._v(" "), (_vm.paydatile) ? _c('div', {
    staticClass: "dialogpay"
  }, [_c('img', {
    staticClass: "payclose",
    attrs: {
      "src": require("../../../statics/imgs/cc.png")
    },
    on: {
      "click": _vm.close1
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "paytitle"
  }, [_vm._v("\n          支付详情\n        ")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "payname"
  }, [_vm._v("\n            " + _vm._s(_vm.goodsInfo.name) + "\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "qpayb"
  }, [_c('span', [_vm._v("￥")]), _vm._v(" "), _c('span', {
    staticClass: "payprice"
  }, [_vm._v(_vm._s(_vm.goodsInfo.price))])]), _vm._v(" "), _c('div', [(_vm.platform == 'wx' || !_vm.platform) ? _c('div', {
    staticClass: "paybx"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    on: {
      "click": _vm.qcheck
    }
  }, [(!_vm.wxcheck) ? _c('img', {
    staticClass: "checkin",
    attrs: {
      "src": require("../../../statics/imgs/wk.png"),
      "mode": ""
    }
  }) : _c('img', {
    staticClass: "checkin",
    attrs: {
      "src": require("../../../statics/imgs/xz.png"),
      "mode": ""
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.platform == 'ali' || !_vm.platform) ? _c('div', {
    staticClass: "paybx"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    on: {
      "click": _vm.qcheck1
    }
  }, [(!_vm.apilcheck) ? _c('img', {
    staticClass: "checkin",
    attrs: {
      "src": require("../../../statics/imgs/wk.png"),
      "mode": ""
    }
  }) : _c('img', {
    staticClass: "checkin",
    attrs: {
      "src": require("../../../statics/imgs/xz.png"),
      "mode": ""
    }
  })])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "qrpaybx"
  }, [_c('div', {
    staticClass: "qrpay",
    on: {
      "click": _vm.quzhifu
    }
  }, [_vm._v("\n              确认支付\n            ")])])])]) : _vm._e(), _vm._v(" "), (_vm.coyshow) ? _c('div', {
    staticClass: "dialogpay"
  }, [_c('div', {
    staticClass: "paytitle"
  }, [_vm._v("\n        支付宝支付\n      ")]), _vm._v(" "), _c('div', [_c('img', {
    staticClass: "payclose",
    attrs: {
      "src": require("../../../statics/imgs/cc.png")
    },
    on: {
      "click": _vm.close2
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tzbx1"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "copy1",
    on: {
      "click": _vm.copy
    }
  }, [_vm._v("\n              复制\n            ")])])]), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5)]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('span', [_vm._v("确认订单")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wxpaybx"
  }, [_c('img', {
    staticClass: "logot",
    attrs: {
      "src": require("../../../statics/imgs/wx.png"),
      "mode": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("微信支付")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wxpaybx"
  }, [_c('img', {
    staticClass: "logot",
    attrs: {
      "src": require("../../../statics/imgs/zfb.png"),
      "mode": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("支付宝支付")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tzbx"
  }, [_c('img', {
    staticClass: "tzbxs",
    attrs: {
      "src": require("../../../statics/imgs/copy.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "coybx"
  }, [_c('div', [_vm._v(" 复制链接")]), _vm._v(" "), _c('div', {
    staticClass: "coy"
  }, [_vm._v(" 点击右侧按钮复制链接")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bzt"
  }, [_c('img', {
    staticClass: "logot logot1",
    attrs: {
      "src": require("../../../statics/imgs/xj.png"),
      "mode": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tzbx"
  }, [_c('div', [_c('img', {
    staticClass: "tzbxs",
    attrs: {
      "src": require("../../../statics/imgs/llq.png"),
      "mode": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "coybx"
  }, [_c('div', [_vm._v("在浏览器粘贴链接")]), _vm._v(" "), _c('div', {
    staticClass: "coy"
  }, [_vm._v("打开手机浏览器，粘贴链接并使用")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53b97572"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modular/goodsDetail.vue
// module id = 534
// module chunks = 0